// Filename - main.js

import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QrReader from "react-qr-reader";
import { useAuthState } from "react-firebase-hooks/auth";
import {  getDoc,  collection,  getDocs,  query,  where, Timestamp, doc, updateDoc} from "firebase/firestore";
import { PersonCheck, PersonCheckFill} from "react-bootstrap-icons";
import Header from './components/Header';
import Footer from './components/Footer';
import './qrreader.css';


const RMQrReader = () => {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  // Add this array of admin emails
  // const ADMIN_EMAILS = [
  //   "dkalappa@gmail.com",
  //   "preet2u@gmail.com",
  //   // Add all admin email addresses here
  // ];

 

  const location = useLocation();
  let tmpLocation;
  if (location.state) 
    tmpLocation = location.state.hotel;
  else {
   
  }
 
  const [message, setMessage] = useState([]);
  const [ticketDetails, setTicketDetails] = useState([]);
  const [clubMembers, setClubMembers] = useState([]);
  const [showClubMembers, setShowClubMembers] = useState(false);
  const allowedFields = ["roommates", "riderprofile", "udf2", "transactionId", "amount", "club", "tshirt", "food", "name"];

 

  const fetchLocalUserDetails = async (pnr, bobmcId, accommodationType) => {
    //   const users = JSON.parse(localStorage.getItem("users"));
    const docRef = doc(db, "RiderMania", "2026", "Registrations", pnr);

    // 2. Fetch the document snapshot
    const querySnapshot = await getDoc(docRef);
    
    //  const query1 = query(c
    if(querySnapshot.empty)
    {      
        console.log("No user found with this PNR.");
        setMessage(
          <>
            Please check the pnr            
          </>
        );
        alert("Please check the pnr ");    
        setTicketDetails("")
      
    }
    else{

      const data = querySnapshot.data();
      const dTicket = displayResults(data, pnr);
      if(data.checkIntime != null){
       
        setMessage("Rider already checked in by "+data.checkedInBY);
        alert("Rider already checked in by "+data.checkedInBY);           
      //  setTicketDetails(dTicket)
      fetchClubMembers(data.club);
      }
      else {
        await updateStatusChecked(querySnapshot.id, data)
        navigate("/rmqrdetails", { state: { dTicket: dTicket } });
      }
    }
   
   
  };

   const updateStatusChecked = async (id, riderData) => {
    // remote Db update
  
    const checkinData = {
      checkIntime: Timestamp.fromDate(new Date()), 
      checkedInBY: name,
    } 
    try {
      
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id);

      await  updateDoc(docRef, checkinData);

      const roommateIdsToUpdate = [];
      if (riderData && riderData.roommates && Array.isArray(riderData.roommates) && riderData.roommates.length > 0) {
         const confirmRoommateCheckin = window.confirm("Do you want to check in the roommate(s) as well?");
        if (confirmRoommateCheckin) 
        {       

          for (const roommateProfileId of riderData.roommates) {
            if (roommateProfileId) {
              const q = query(collection(db, "RiderMania", "2026", "Registrations"), where("riderprofile", "==", roommateProfileId));
              const roommateQuerySnapshot = await getDocs(q);
              if (!roommateQuerySnapshot.empty) {
                const roommateDoc = roommateQuerySnapshot.docs[0];
                roommateIdsToUpdate.push(roommateDoc.id);
                await updateDoc(roommateDoc.ref, checkinData);
              } else {
                console.warn(`Roommate with riderprofile ${roommateProfileId} not found.`);
              }
            }
          }
        }
        
      }

       // Update the local state to reflect the change
       const allCheckedInIds = [id, ...roommateIdsToUpdate];
       setClubMembers(prevMembers => 
        prevMembers.map(member => 
          allCheckedInIds.includes(member.id)
            ? { ...member, checkIntime: Timestamp.fromDate(new Date()),  checkedInBY: name,}
            : member
        )
      );  
    
    } catch (e) {
      console.error("Error updating check-in status:", e);
    }
  
  
  };


  const displayResults = (data, pnr) => {
          
    const ticket = {};
   
    ticket["type"] = data.udf2;       
    ticket["pnr"] = data.riderprofile;
    ticket["name"] = data.name;     
    ticket["club"] = data.club;    
    ticket["roommates"] = data.roommates;
      
    return ticket
  };
  
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    setName(user?.email);
  
  }, [user, loading]);

  const navigate = useNavigate();

  const previewStyle = {
    height: 240,
    width: 320,
  };
  const constraints = {
    facingMode: "environment",
  };
  const [result, setResult] = useState("No result");

  const  handleScan = (data) => {
   
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        if (parsedData.regId) {
          fetchLocalUserDetails(parsedData.regId, parsedData.bobmcId, parsedData.accommodation);
          return;
        }
      } catch (e) {
        console.log("QR code is not JSON, attempting regex match.");
      }
      
    }
  }; 

  const handleError = (error) => {
    console.error(error);
  };

  const fetchClubMembers = async (clubName) => {
    try {
    
      const q = query(
        collection(db, "RiderMania", "2026", "Registrations"), 
        where("club", "==", clubName)
      );
      const querySnapshot = await getDocs(q);
      const members = querySnapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(member => member.status === "success"); // Filter out members without PNR
       // Sort the users list 
       members.sort((a, b) => { 
        if (a.name < b.name) 
          return -1; 
        if (a.name > b.name) 
          return 1; 
        return 0; 
      });
        
      setClubMembers(members);
      setShowClubMembers(true);
    } catch (error) {
      console.error("Error fetching club members:", error);
    

      
    }
  };

  const checkInAllByRoomType = async (roomType) => {
    const membersToCheckIn = clubMembers.filter(
      (member) => member.udf2 === roomType && !member.checkIntime
    );

    if (membersToCheckIn.length === 0) {
      alert(`All members for ${roomType} are already checked in.`);
      return;
    }

    const isConfirmed = window.confirm(
      `Are you sure you want to check in all ${membersToCheckIn.length} members for ${roomType}?`
    );

    if (!isConfirmed) {
      return;
    }

    const checkinData = {
      checkIntime: Timestamp.fromDate(new Date()),
      checkedInBY: name,
    };

    try {
      const updatePromises = membersToCheckIn.map((member) => {
        const docRef = doc(db, "RiderMania", "2026", "Registrations", member.id);
        return updateDoc(docRef, checkinData);
      });

      await Promise.all(updatePromises);

      // Update local state
      const checkedInIds = membersToCheckIn.map((m) => m.id);
      setClubMembers((prevMembers) =>
        prevMembers.map((member) =>
          checkedInIds.includes(member.id) ? { ...member, ...checkinData } : member
        )
      );

      alert(`Successfully checked in ${membersToCheckIn.length} members for ${roomType}.`);
    } catch (error) {
      console.error("Error checking in all members by room type:", error);
      alert("An error occurred during bulk check-in.");
    }
  };

  const removeStatusChecked = async (id) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to remove the check-in status?");
    
    if (!isConfirmed) {
      return; // Exit if user cancels
    }
  
    // Remove check-in data
    const checkinData = {
      checkIntime: null,            
      checkedInBY: null,
      checkedOutBY: name,
      checkedOutTime: Timestamp.fromDate(new Date()),
    } 
  
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
      await updateDoc(docRef, checkinData);
      
      // Update the local state to reflect the change
      setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, checkIntime: null, checkedInBY: null }
            : member
        )
      );  
        
    } catch (error) {
      console.error("Error removing check-in status:", error);
      alert("Error removing check-in status");
    } 
  };

  return (
    <>
    <div className="dashboard-container">
    <Header 
     title="Rider Mania Check-In"
     showBack={false}
     showDashboard={true}
   />

    
      {user ? (
        <main className="dashboard-main">      
      
            <div className="center-wrapper" align="center">
             
              <div className="text-danger">{message}</div>
              <br />
          
              <QrReader
                delay={500}
                onError={handleError}
                onScan={handleScan}
                style={previewStyle}
                facingMode={"environment"}
              />
            </div>
            
          <br clear="all" />
         
          <div style={{ marginTop: '6em' , marginBottom:'2em' ,color: 'var(--text-color, #f8f9fa) '}}>
          <div className="admin-controls mb-4" style={{ color: 'var(--text-color, #f8f9fa) '}}>
          {/* Admin button */}
          {isAdmin && (
           ticketDetails && Object.keys(ticketDetails).length > 0 && (
            <div className="admin-controls mt-4" style={{ color: 'var(--text-color, #f8f9fa) '}}>
              <button 
                className="btn btn-primary"
                onClick={() => navigate("/clubReader", { state: { club: ticketDetails.club } })}   

              >
                Club Check-ins
              </button>
            </div>
          )
        )
        }
              </div>
             
          {/* Ticket Details Table */}
          {!showClubMembers && Object.entries(ticketDetails).filter(([key]) => allowedFields.includes(key)).map(([key, value]) => (
         <div className="ticket-details-container" key={key}>    
              <div className="trow" style={{ color: 'var(--text-color, #f8f9fa) '}}>
                <div className="cell uppercase">
                  <strong>{key}</strong>
                </div>
                <div className="cell text-break">
                  {key === "club" ? (
                    <div className="" style={{ color: 'var(--text-color, #f8f9fa) '}}>
                      <span className="me-2">{value}</span>
                      <button 
                        className="btn btn-sm btn-primary"
                        onClick={() => fetchClubMembers(value)}
                      >
                        View
                      </button>
                    </div>
                  ) : (typeof value === 'object' && value !== null ? (
                      value.seconds ? new Date(value.seconds * 1000).toLocaleString() : JSON.stringify(value)
                    ) : value
                  )}
                </div>
              </div>
            </div>
          ))}
         
          {/* Club Members Table */}
          {showClubMembers && (
            <div style={{ color: 'var(--text-color, #f8f9fa) '}}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>{clubMembers.length > 0 ? `${clubMembers[0].club} Members` : 'Club Members'}</h4>
              </div>
              <div className="mb-3 p-2 rounded" style={{backgroundColor: 'var(--card-bg-color, #212529)'}}>
                <span className="me-3 fw-bold">Bulk Check-in:</span>
                {[...new Set(clubMembers.map(member => member.udf2).filter(Boolean))].map((roomType) => (
                    <button
                        key={roomType}
                        className="btn btn-sm btn-info me-2"
                        onClick={() => checkInAllByRoomType(roomType)}
                    >
                       {roomType}
                    </button>
                ))}
              </div>
              <div className="table-responsive mt-3">
                <table className="table" style={{ color: 'var(--text-color, #f8f9fa) ',backgroundColor: 'var(--card-bg-color, #212529)'}}>
                  <thead>
                  <tr>
                      <th>Name<br></br>Rider Profile</th>   
                      <th>Room type</th>
                          
                      <th>Check-in Status</th>
                    </tr>
                  </thead>
                  <tbody >
                  {clubMembers.map((member) => (
                      <tr key={member.id}>
                        <td>{member.name}<br></br>{member.riderprofile}</td>          
                        <td>{member.udf2}</td>                            
                        <td>
                          {member.checkIntime ? (
                            <span className="text-success">
                              <PersonCheckFill className="text-success" size={20} onClick={()=> removeStatusChecked(member.id) }/>
                            </span>
                          ) : (
                            <span style={{ cursor: 'pointer' }} className="text-warning"><PersonCheck className="text-warning" size={20} onClick={()=> updateStatusChecked(member.id) }/></span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          </div>
        </main>

      ) : (
        
          <h3>404 Page Not Found </h3>
       
      )}
     
    </div>
    <Footer />
    </>
  );
};

export default RMQrReader;
